export default __webpack_public_path__ + "static/media/2.941bfa74.jpeg";